module.exports = __webpack_public_path__ + "img/home_htsk.ff030230.png";